import React from "react"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"

const MantineHideColumnTrigger = ({ sheetKey, columnId, isHidden, handleHideColumn }) => {
    const handleClick = () => {
        if (columnId) {
            return handleHideColumn(sheetKey, columnId, !isHidden)
        }
        return handleHideColumn(sheetKey, !isHidden)
    }

    return isHidden ? (
        <Tooltip label="Click to unhide this column from externally shared sheets">
            <Icon name={"fa-toggle-off"} onClick={handleClick} />
        </Tooltip>
    ) : (
        <Tooltip label="Click to hide this column from externally shared sheets">
            <Icon name={"fa-toggle-on"} onClick={handleClick} />
        </Tooltip>
    )
}

export default MantineHideColumnTrigger
